export type SitePage = {
  path: string
  navLabel: string
  title: string
  description: string
  eyebrow: string
  heading: string
  intro: string
  benefit: string
  steps: [string, string, string]
  related: string[]
  image: 'hero' | 'background' | 'gallery'
}

export type PageSeoDetail = {
  input: string
  output: string
  limitation: string
  scenarioNotes: [string, string, string, string]
  faq: [string, string][]
}

export const pages: SitePage[] = [
  {
    path: '/',
    navLabel: 'Главная',
    title: 'Canva на русском: дизайн, фото и презентации онлайн',
    description: 'Создавайте презентации, изображения и визуальные материалы в понятном онлайн-редакторе Canva.',
    eyebrow: 'Онлайн-редактор',
    heading: 'Создавайте дизайн быстрее и проще',
    intro: 'Фото, презентации и готовые макеты в одном понятном онлайн-редакторе.',
    benefit: 'От идеи до готового визуального материала без переключения между разными инструментами.',
    steps: ['Выберите формат', 'Добавьте материалы', 'Скачайте результат'],
    related: ['/foto/', '/ai/', '/dizajn/'],
    image: 'hero',
  },
  {
    path: '/nejroset-dlya-prezentacij/',
    navLabel: 'Нейросеть для презентаций',
    title: 'Нейросеть для презентаций: создать слайды онлайн',
    description: 'Подготовьте структуру и визуальную основу презентации по теме, затем отредактируйте слайды в Canva.',
    eyebrow: 'ИИ для презентаций',
    heading: 'Презентация начинается с вашей темы',
    intro: 'Опишите задачу, получите основу слайдов и спокойно доработайте структуру, изображения и оформление.',
    benefit: 'Подходит для учебных, рабочих и коммерческих презентаций, когда нужно быстро перейти от мысли к первому макету.',
    steps: ['Опишите тему', 'Проверьте структуру', 'Настройте слайды'],
    related: ['/ai/', '/sozdat-dizajn/', '/dizajn/'],
    image: 'gallery',
  },
  {
    path: '/nejroset-dlya-foto/',
    navLabel: 'Нейросеть для фото',
    title: 'Нейросеть для фото: обработка изображений онлайн',
    description: 'Используйте ИИ-инструменты Canva для обработки фото, фона и объектов в одном редакторе.',
    eyebrow: 'ИИ для фото',
    heading: 'Меняйте фотографию по задаче',
    intro: 'Уберите лишнее, замените фон или подготовьте изображение к публикации с помощью ИИ-инструментов.',
    benefit: 'Все изменения остаются в одном макете, поэтому результат можно сразу дополнить текстом и графикой.',
    steps: ['Загрузите фото', 'Выберите изменение', 'Доработайте результат'],
    related: ['/redaktor-foto/', '/udalit-fon/', '/dobavit-udalit-obekt-na-foto/'],
    image: 'background',
  },
  {
    path: '/nejroset-dlya-izobrazhenij/',
    navLabel: 'ИИ для изображений',
    title: 'Нейросеть для изображений: создать и изменить картинку',
    description: 'Создавайте варианты изображений по описанию и продолжайте работу с ними в редакторе Canva.',
    eyebrow: 'ИИ-изображения',
    heading: 'От описания к готовому изображению',
    intro: 'Сформулируйте сюжет и стиль, сравните варианты и используйте подходящий результат в своём дизайне.',
    benefit: 'Страница собрана для сценария генерации и последующего редактирования, а не общей обработки фотографий.',
    steps: ['Опишите сюжет', 'Выберите вариант', 'Добавьте в дизайн'],
    related: ['/generator-izobrazhenij/', '/ai/', '/sozdat-dizajn/'],
    image: 'gallery',
  },
  {
    path: '/generator-izobrazhenij/',
    navLabel: 'Генератор изображений',
    title: 'Генератор изображений по тексту онлайн',
    description: 'Создавайте изображения по текстовому описанию, выбирайте стиль и дорабатывайте результат в Canva.',
    eyebrow: 'Генератор изображений',
    heading: 'Создавайте изображения по описанию',
    intro: 'Задайте сюжет, настроение и формат, чтобы получить несколько визуальных направлений для дальнейшей работы.',
    benefit: 'Полезно, когда исходного изображения ещё нет и нужен новый визуал под конкретный сюжет.',
    steps: ['Введите запрос', 'Сравните варианты', 'Настройте формат'],
    related: ['/nejroset-dlya-izobrazhenij/', '/ai/', '/dizajn/'],
    image: 'gallery',
  },
  {
    path: '/zamenit-fon-na-foto/',
    navLabel: 'Заменить фон',
    title: 'Заменить фон на фото онлайн',
    description: 'Удалите исходный фон, выберите новый и продолжайте редактирование фотографии в Canva.',
    eyebrow: 'Замена фона',
    heading: 'Меняйте фон, сохраняя главное',
    intro: 'Загрузите фотографию, выберите новый фон и продолжите работу с результатом в том же редакторе.',
    benefit: 'Подходит для карточек товаров, портретов, публикаций и других задач, где объект должен остаться в центре внимания.',
    steps: ['Загрузите фото', 'Выберите новый фон', 'Проверьте края'],
    related: ['/udalit-fon/', '/redaktor-foto/', '/foto/'],
    image: 'background',
  },
  {
    path: '/udalit-fon/',
    navLabel: 'Удалить фон',
    title: 'Удалить фон с изображения онлайн',
    description: 'Отделите объект от фона и используйте результат в новом макете Canva.',
    eyebrow: 'Удаление фона',
    heading: 'Оставьте объект без лишнего фона',
    intro: 'Подготовьте изображение с прозрачным или новым фоном для карточки, презентации или публикации.',
    benefit: 'Главная задача этой страницы — аккуратно отделить объект, а не полностью переработать фотографию.',
    steps: ['Добавьте изображение', 'Удалите фон', 'Поместите в макет'],
    related: ['/zamenit-fon-na-foto/', '/redaktor-foto/', '/foto/'],
    image: 'background',
  },
  {
    path: '/dobavit-udalit-obekt-na-foto/',
    navLabel: 'Объекты на фото',
    title: 'Добавить или удалить объект на фото онлайн',
    description: 'Уберите лишний объект или дополните композицию фотографии с помощью инструментов Canva.',
    eyebrow: 'Редактирование объектов',
    heading: 'Исправляйте композицию фотографии',
    intro: 'Выделите ненужную область или добавьте подходящий элемент, не покидая рабочий макет.',
    benefit: 'Сценарий сфокусирован на отдельных объектах и деталях кадра, а не на общей коррекции фото.',
    steps: ['Откройте фото', 'Выделите область', 'Оцените результат'],
    related: ['/nejroset-dlya-foto/', '/redaktor-foto/', '/ai/'],
    image: 'background',
  },
  {
    path: '/obedinit-foto/',
    navLabel: 'Объединить фото',
    title: 'Объединить несколько фото онлайн',
    description: 'Соберите коллаж, сравнение или единую композицию из нескольких фотографий в Canva.',
    eyebrow: 'Композиция из фото',
    heading: 'Соберите несколько кадров в один макет',
    intro: 'Расположите фотографии рядом, настройте размеры и добавьте фон, подписи или графические элементы.',
    benefit: 'Подходит для сравнений, подборок, историй, коллажей и презентационных материалов.',
    steps: ['Загрузите снимки', 'Выберите композицию', 'Настройте отступы'],
    related: ['/foto/', '/redaktor-foto/', '/sozdat-dizajn/'],
    image: 'gallery',
  },
  {
    path: '/ozhivit-foto/',
    navLabel: 'Оживить фото',
    title: 'Оживить фото: добавить движение онлайн',
    description: 'Добавьте фотографии движение и подготовьте динамичный визуальный материал в Canva.',
    eyebrow: 'Динамичное фото',
    heading: 'Добавьте статичному кадру движение',
    intro: 'Выберите фотографию, настройте визуальный эффект и используйте результат в публикации или истории.',
    benefit: 'Страница отвечает на задачу анимации готового кадра и не пересекается с генерацией нового изображения.',
    steps: ['Выберите фото', 'Добавьте эффект', 'Настройте длительность'],
    related: ['/foto/', '/nejroset-dlya-foto/', '/dizajn/'],
    image: 'hero',
  },
  {
    path: '/sozdat-dizajn/',
    navLabel: 'Создать дизайн',
    title: 'Создать дизайн онлайн в Canva',
    description: 'Выберите формат, добавьте материалы и соберите готовый дизайн в онлайн-редакторе Canva.',
    eyebrow: 'Создание дизайна',
    heading: 'Начните с идеи, закончите готовым дизайном',
    intro: 'Выберите формат, шаблон или пустой макет и соберите визуальный материал под свою задачу.',
    benefit: 'Это стартовая страница для создания нового макета, а разделы Фото и ИИ помогают решить отдельные подзадачи.',
    steps: ['Выберите формат', 'Соберите композицию', 'Подготовьте результат'],
    related: ['/dizajn/', '/nejroset-dlya-prezentacij/', '/generator-izobrazhenij/'],
    image: 'hero',
  },
  {
    path: '/redaktor-foto/',
    navLabel: 'Редактор фото',
    title: 'Редактор фото онлайн: обработать изображение',
    description: 'Настройте свет, цвет, кадрирование, фон и детали фотографии в редакторе Canva.',
    eyebrow: 'Редактор фото',
    heading: 'Все основные правки в одном редакторе',
    intro: 'Кадрируйте снимок, настройте изображение и добавьте текст или графику в едином рабочем пространстве.',
    benefit: 'Общий редактор объединяет базовую обработку, тогда как отдельные страницы раскрывают конкретные операции.',
    steps: ['Откройте снимок', 'Настройте изображение', 'Сохраните формат'],
    related: ['/foto/', '/nejroset-dlya-foto/', '/udalit-fon/'],
    image: 'background',
  },
  {
    path: '/foto/',
    navLabel: 'Фото',
    title: 'Инструменты Canva для работы с фото',
    description: 'Выберите инструмент Canva для редактирования, объединения, анимации или изменения фона фотографии.',
    eyebrow: 'Раздел Фото',
    heading: 'Все задачи с фотографиями по направлениям',
    intro: 'Найдите подходящий сценарий: общая обработка, фон, объекты, объединение кадров или движение.',
    benefit: 'Хаб помогает перейти к конкретной операции и не конкурирует со страницами отдельных инструментов.',
    steps: ['Определите задачу', 'Откройте инструмент', 'Работайте с фото'],
    related: ['/redaktor-foto/', '/zamenit-fon-na-foto/', '/obedinit-foto/'],
    image: 'background',
  },
  {
    path: '/ai/',
    navLabel: 'ИИ',
    title: 'ИИ-инструменты Canva для изображений и презентаций',
    description: 'Найдите ИИ-инструмент Canva для генерации изображений, работы с фото или создания презентаций.',
    eyebrow: 'Раздел ИИ',
    heading: 'ИИ-инструменты собраны по задачам',
    intro: 'Выберите создание нового изображения, обработку фотографии или подготовку презентации по теме.',
    benefit: 'Хаб объясняет различия между сценариями и направляет на специализированную страницу.',
    steps: ['Выберите сценарий', 'Сформулируйте запрос', 'Доработайте результат'],
    related: ['/generator-izobrazhenij/', '/nejroset-dlya-foto/', '/nejroset-dlya-prezentacij/'],
    image: 'gallery',
  },
  {
    path: '/dizajn/',
    navLabel: 'Дизайн',
    title: 'Дизайн в Canva: форматы, макеты и инструменты',
    description: 'Перейдите к созданию презентации, публикации, изображения или другого визуального материала в Canva.',
    eyebrow: 'Раздел Дизайн',
    heading: 'Выберите формат под свою задачу',
    intro: 'Начните с презентации, публикации, карточки, афиши или пустого макета и соберите целостный визуал.',
    benefit: 'Раздел объединяет форматы и сценарии создания, не подменяя страницы отдельных редакторов.',
    steps: ['Определите формат', 'Выберите основу', 'Соберите дизайн'],
    related: ['/sozdat-dizajn/', '/nejroset-dlya-prezentacij/', '/foto/'],
    image: 'hero',
  },
]

export const pageByPath = new Map(pages.map((page) => [page.path, page]))

export const pageSeoDetails: Record<string, PageSeoDetail> = {
  '/': {
    input: 'Можно начать с формата, собственного изображения, текста или пустого макета.',
    output: 'На выходе получается редактируемый визуальный материал, который можно проверить и подготовить под нужную площадку.',
    limitation: 'Набор доступных функций и вариантов экспорта зависит от внешнего редактора и выбранного аккаунта.',
    scenarioNotes: ['Выберите направление по типу результата.', 'Сопоставьте задачу с подходящим инструментом.', 'Проверьте формат перед переходом.', 'Продолжите работу во внешнем редакторе.'],
    faq: [
      ['Какие задачи собраны на сайте?', 'Сайт помогает выбрать сценарий для презентаций, фотографий, ИИ-изображений и других визуальных материалов.'],
      ['Где происходит редактирование?', 'Основные кнопки открывают внешний онлайн-редактор через служебный переход /go/.'],
      ['С чего лучше начать?', 'Если у вас уже есть фотография, откройте раздел «Фото». Для нового макета подойдёт раздел «Дизайн», а для генерации — раздел «ИИ».'],
    ],
  },
  '/nejroset-dlya-prezentacij/': {
    input: 'Подготовьте тему, исходный текст или краткий план и заранее определите аудиторию выступления.',
    output: 'Проверьте логику структуры, объём текста на слайдах, последовательность аргументов и единый визуальный стиль.',
    limitation: 'ИИ создаёт основу, но факты, формулировки и финальную подачу нужно проверить перед выступлением.',
    scenarioNotes: ['Соберите понятную логику учебного доклада.', 'Покажите ценность и условия коммерческого предложения.', 'Разделите показатели и выводы командного отчёта.', 'Сверьте слайды с ходом будущего выступления.'],
    faq: [
      ['Можно ли создать презентацию только по теме?', 'Да, тему можно использовать как отправную точку для структуры, а затем уточнить содержание и оформление слайдов.'],
      ['Подойдёт ли готовый текст или документ?', 'Готовый материал помогает точнее собрать план. Перед публикацией проверьте, как текст распределён между слайдами.'],
      ['Что обязательно проверить в ИИ-презентации?', 'Проверьте факты, последовательность тезисов, читаемость слайдов, качество изображений и соответствие аудитории.'],
    ],
  },
  '/nejroset-dlya-foto/': {
    input: 'Используйте исходный кадр достаточного размера, где главный объект хорошо отделяется от окружения.',
    output: 'Сравните исходник и результат, уделяя внимание лицам, мелким деталям, границам объекта и естественности света.',
    limitation: 'Сложные перекрытия, волосы, прозрачные предметы и низкое качество исходника могут потребовать ручной доработки.',
    scenarioNotes: ['Подготовьте кадр под размер публикации.', 'Сохраните читаемую форму товара и его детали.', 'Проверьте лицо, волосы и естественность кожи.', 'Согласуйте изображение со стилем презентации.'],
    faq: [
      ['Чем нейросеть для фото отличается от обычного редактора?', 'ИИ-инструменты помогают менять отдельные элементы и фон, а обычный редактор нужен для кадрирования, света, цвета и композиции.'],
      ['Какие фотографии дают более предсказуемый результат?', 'Лучше подходят резкие снимки с понятным главным объектом, достаточным разрешением и без сильных перекрытий.'],
      ['Нужно ли проверять результат после ИИ-обработки?', 'Да, внимательно посмотрите на лица, руки, текст, контуры и повторяющиеся детали перед использованием изображения.'],
    ],
  },
  '/nejroset-dlya-izobrazhenij/': {
    input: 'Определите, нужен ли новый визуал по описанию или изменение уже существующего изображения.',
    output: 'Оцените композицию, соответствие запросу, пригодность формата и возможность дальнейшего редактирования.',
    limitation: 'Эта страница помогает выбрать ИИ-сценарий; для генерации с нуля предусмотрен отдельный генератор изображений.',
    scenarioNotes: ['Подберите иллюстрацию под смысл статьи.', 'Сравните несколько рекламных концепций.', 'Задайте фон с нужным настроением и свободным местом.', 'Соберите обложку с ясной визуальной иерархией.'],
    faq: [
      ['Когда нужен генератор, а когда ИИ-редактирование?', 'Генератор подходит, если исходного изображения нет. ИИ-редактирование используют, когда нужно изменить существующий материал.'],
      ['Что указать в описании изображения?', 'Опишите главный объект, окружение, стиль, настроение, формат и важные ограничения композиции.'],
      ['Почему стоит сравнивать несколько вариантов?', 'Варианты помогают выбрать удачную композицию и заметить ошибки до дальнейшей работы с текстом и макетом.'],
    ],
  },
  '/generator-izobrazhenij/': {
    input: 'Сформулируйте промпт: главный объект, действие, окружение, свет, стиль и требуемое соотношение сторон.',
    output: 'Выберите вариант с подходящей композицией и проверьте лица, руки, текстовые элементы и мелкие детали.',
    limitation: 'Генератор создаёт новый визуал, но не гарантирует точность фактов, надписей, логотипов и сложной геометрии.',
    scenarioNotes: ['Опишите материал, свет и ракурс предметной сцены.', 'Задайте характер формы и цветовой ритм.', 'Оставьте место для заголовка редакционной иллюстрации.', 'Сразу укажите вертикальный или горизонтальный формат.'],
    faq: [
      ['Как написать запрос для генератора изображений?', 'Начните с объекта и действия, затем добавьте окружение, свет, стиль, ракурс и формат. Важные запреты сформулируйте отдельно.'],
      ['Можно ли получить изображение нужного размера?', 'Формат и соотношение сторон лучше определить до генерации, а точный размер проверить при подготовке итогового макета.'],
      ['Какие ошибки встречаются в сгенерированных изображениях?', 'Нужно проверять анатомию, мелкие предметы, повторяющиеся детали, надписи, логотипы и физически сложные сцены.'],
    ],
  },
  '/zamenit-fon-na-foto/': {
    input: 'Выберите резкое фото с хорошо видимым объектом и подготовьте новый фон подходящего размера и освещения.',
    output: 'Проверьте края объекта, направление света, перспективу, тени и соответствие нового окружения исходному кадру.',
    limitation: 'Тонкие волосы, прозрачные детали и сложный исходный фон могут потребовать ручной коррекции маски.',
    scenarioNotes: ['Сохраните форму товара и добавьте чистое окружение.', 'Подберите нейтральный фон без потери деталей портрета.', 'Согласуйте фон с темой и контрастом анонса.', 'Оставьте безопасное место для текста публикации.'],
    faq: [
      ['Чем замена фона отличается от удаления фона?', 'При удалении получается отделённый объект или прозрачный фон. При замене объект сразу помещается в новое окружение.'],
      ['Как выбрать подходящий новый фон?', 'Сопоставьте перспективу, направление света, цветовую температуру и масштаб объекта с будущим окружением.'],
      ['Что проверить по краям объекта?', 'Посмотрите на волосы, полупрозрачные детали, мелкие выступы, цветовые ореолы и естественность контактной тени.'],
    ],
  },
  '/udalit-fon/': {
    input: 'Загрузите изображение с различимым главным объектом; контраст с фоном помогает точнее определить границы.',
    output: 'Проверьте прозрачность, края, отверстия внутри объекта и сохранность тонких деталей перед экспортом.',
    limitation: 'Полупрозрачные предметы, мех, волосы и совпадающие с фоном цвета могут потребовать уточнения выделения.',
    scenarioNotes: ['Подготовьте единообразные объекты для каталога.', 'Разместите вырезанный объект поверх новой композиции.', 'Сохраните прозрачность для гибкого макета слайдов.', 'Проверьте контраст объекта на будущем фоне баннера.'],
    faq: [
      ['В каком формате сохраняют изображение без фона?', 'Для прозрачности обычно используют PNG. Перед сохранением убедитесь, что выбранный формат поддерживает альфа-канал.'],
      ['Почему после удаления остаётся цветной контур?', 'Ореол может появиться из пикселей старого фона. Край маски нужно проверить и при необходимости скорректировать.'],
      ['Можно ли после удаления добавить другой фон?', 'Да, отделённый объект можно поместить на цвет, фотографию или другой макет и настроить масштаб и тень.'],
    ],
  },
  '/dobavit-udalit-obekt-na-foto/': {
    input: 'Откройте исходное фото и точно обозначьте область, которую нужно очистить или дополнить.',
    output: 'Проверьте, продолжает ли изменённая область фон, текстуру, свет и перспективу окружающего кадра.',
    limitation: 'Крупные объекты, перекрывающие важные детали, сложнее восстановить без заметных артефактов.',
    scenarioNotes: ['Уберите отвлекающую деталь и восстановите фон.', 'Добавьте объект с подходящим масштабом и светом.', 'Исправьте локальный дефект без изменения всего кадра.', 'Проверьте правдоподобие рекламной композиции.'],
    faq: [
      ['Как аккуратно удалить лишний объект?', 'Выделяйте объект вместе с небольшим запасом и после обработки проверяйте повторяющиеся текстуры, края и тени.'],
      ['Что важно при добавлении нового объекта?', 'Сопоставьте масштаб, перспективу, направление света, резкость и цветовую температуру с исходной фотографией.'],
      ['Можно ли восстановить фон за крупным объектом?', 'Результат зависит от окружающего контекста. Чем меньше видимой информации о скрытой области, тем важнее ручная проверка.'],
    ],
  },
  '/obedinit-foto/': {
    input: 'Подготовьте снимки близкого качества и заранее выберите цель: коллаж, сравнение, фотолента или история.',
    output: 'Проверьте порядок кадров, выравнивание, интервалы, общий размер и читаемость композиции на целевом экране.',
    limitation: 'Сильно различающиеся пропорции и качество снимков могут потребовать отдельного кадрирования каждого изображения.',
    scenarioNotes: ['Разместите состояния до и после в сопоставимом масштабе.', 'Выберите сетку и единый ритм отступов.', 'Покажите товары в одинаковых визуальных условиях.', 'Выстройте кадры в понятной хронологии.'],
    faq: [
      ['Как объединить фото без обрезки важных деталей?', 'Сначала выберите сетку под пропорции снимков, затем настройте масштаб и положение каждого кадра отдельно.'],
      ['Можно ли добавить подписи и фон?', 'Да, после размещения снимков композицию можно дополнить фоном, текстом и графическими акцентами.'],
      ['Какой формат выбрать для результата?', 'Формат зависит от площадки: для публикации нужен размер ленты, для презентации — размер слайда, для печати — достаточное разрешение.'],
    ],
  },
  '/ozhivit-foto/': {
    input: 'Выберите чёткую фотографию и определите, какое движение уместно: камера, фон или отдельный объект.',
    output: 'Проверьте направление, амплитуду и длительность движения, а также неподвижные области и зацикливание.',
    limitation: 'Сильное движение и сложные перекрытия могут искажать лица, границы предметов и фон.',
    scenarioNotes: ['Добавьте короткое движение без потери читаемости истории.', 'Согласуйте динамику с композицией обложки.', 'Оставьте безопасное время для чтения текста анонса.', 'Используйте движение как акцент, а не помеху слайду.'],
    faq: [
      ['Какие фотографии лучше подходят для оживления?', 'Используйте резкий кадр с понятным объектом и достаточным свободным пространством вокруг предполагаемого движения.'],
      ['Как выбрать длительность эффекта?', 'Короткое движение подходит для ленты и обложек; более длинный фрагмент нужно проверять вместе с текстом и площадкой.'],
      ['Что проверить перед сохранением?', 'Посмотрите на края объекта, лицо, фон, повтор цикла, резкие скачки и читаемость всей композиции.'],
    ],
  },
  '/sozdat-dizajn/': {
    input: 'Определите площадку, размер, ключевой текст и материалы, которые должны войти в новый макет.',
    output: 'Готовый дизайн должен иметь ясную иерархию, безопасные поля, читаемый текст и подходящий формат экспорта.',
    limitation: 'Шаблон ускоряет старт, но содержание, факты, права на материалы и финальную композицию проверяет пользователь.',
    scenarioNotes: ['Соберите публикацию под требования площадки.', 'Разместите ключевые данные и визуальный акцент афиши.', 'Сохраните логику и единый стиль слайдов.', 'Покажите товар, название и важное действие без перегруза.'],
    faq: [
      ['С чего начать новый дизайн?', 'Сначала выберите площадку и размер, затем соберите текст и изображения и только после этого уточняйте стиль.'],
      ['Нужен ли готовый шаблон?', 'Шаблон помогает быстрее определить структуру, но можно начать и с пустого макета, если композиция уже продумана.'],
      ['Что проверить перед экспортом?', 'Проверьте размер, поля, контраст, орфографию, качество изображений и формат файла для выбранной площадки.'],
    ],
  },
  '/redaktor-foto/': {
    input: 'Откройте исходное изображение в максимальном доступном качестве и определите целевой размер.',
    output: 'Сравните кадрирование, экспозицию, цвет, резкость и читаемость добавленного текста на итоговом масштабе.',
    limitation: 'Сильная коррекция не восстанавливает детали, которых нет в исходнике, и может подчеркнуть шум или артефакты.',
    scenarioNotes: ['Сохраните главный объект при кадрировании.', 'Настройте свет и цвет без потери деталей.', 'Проверьте контраст текста поверх изображения.', 'Экспортируйте размер и формат под площадку.'],
    faq: [
      ['Какие правки лучше сделать сначала?', 'Начните с кадрирования и перспективы, затем настройте свет и цвет, после чего добавляйте текст и графику.'],
      ['Как не потерять качество изображения?', 'Работайте с исходником достаточного размера и не увеличивайте маленькое изображение значительно выше его разрешения.'],
      ['Чем редактор фото отличается от отдельных ИИ-инструментов?', 'Редактор объединяет базовые настройки, а специализированные страницы решают точечные задачи с фоном, объектами или генерацией.'],
    ],
  },
  '/foto/': {
    input: 'Определите, что нужно изменить: весь кадр, фон, отдельный объект, композицию из нескольких фото или движение.',
    output: 'Раздел направляет к специализированному сценарию, где можно проверить результат и продолжить редактирование.',
    limitation: 'Хаб не заменяет отдельный инструмент: для каждой операции действуют свои требования к исходнику и проверке.',
    scenarioNotes: ['Выберите базовую обработку снимка.', 'Перейдите к удалению или замене фона.', 'Соберите несколько кадров в композицию.', 'Добавьте умеренное движение готовой фотографии.'],
    faq: [
      ['Как выбрать подходящий инструмент для фото?', 'Для общей коррекции откройте редактор фото, для заднего плана — удаление или замену фона, для деталей — работу с объектами.'],
      ['Можно ли объединить несколько операций?', 'Да, результат одной операции можно продолжить в макете: например, удалить фон, добавить новый и затем включить изображение в коллаж.'],
      ['Как сохранить качество на разных этапах?', 'Используйте исходник достаточного размера, избегайте многократного сильного увеличения и проверяйте итоговый формат.'],
    ],
  },
  '/ai/': {
    input: 'Определите тип исходной задачи: новая картинка по описанию, изменение фотографии или подготовка презентации.',
    output: 'После выбора сценария сравните варианты, проверьте факты и визуальные детали и продолжите работу в макете.',
    limitation: 'ИИ ускоряет подготовку основы, но не заменяет проверку содержания, прав на материалы и качества результата.',
    scenarioNotes: ['Создайте новый визуал по подробному описанию.', 'Измените существующий кадр и проверьте детали.', 'Соберите структуру и основу презентации.', 'Сравните несколько вариантов перед выбором.'],
    faq: [
      ['Какой ИИ-инструмент выбрать?', 'Для нового визуала подойдёт генератор изображений, для готового кадра — нейросеть для фото, для слайдов — нейросеть для презентаций.'],
      ['Нужно ли проверять результат ИИ?', 'Да, проверяйте факты, текст, лица, руки, мелкие детали, композицию и соответствие исходной задаче.'],
      ['Можно ли доработать выбранный вариант?', 'Да, подходящий результат можно включить в макет и дополнить текстом, графикой и другими материалами.'],
    ],
  },
  '/dizajn/': {
    input: 'Сначала определите носитель: презентация, публикация, афиша, карточка товара или другой формат.',
    output: 'Проверьте размер, композицию, иерархию текста, качество изображений и пригодность файла для площадки.',
    limitation: 'Каталог помогает выбрать направление; точные возможности и экспорт зависят от внешнего редактора и аккаунта.',
    scenarioNotes: ['Выберите формат слайда и структуру подачи.', 'Согласуйте макет с размером социальной сети.', 'Оставьте место для даты, места и основного действия.', 'Покажите товар и ключевую информацию в первом взгляде.'],
    faq: [
      ['Как выбрать формат дизайна?', 'Ориентируйтесь на площадку, способ просмотра и объём информации: эти параметры определяют размер и структуру макета.'],
      ['Можно ли изменить размер после создания?', 'Макет можно адаптировать, но после изменения пропорций нужно заново проверить кадрирование, поля и переносы текста.'],
      ['Что делает дизайн читаемым?', 'Ясная иерархия, достаточный контраст, ограниченное число акцентов, ровные отступы и подходящий размер текста.'],
    ],
  },
}

export function getPageFaq(page: SitePage): [string, string][] {
  const details = pageSeoDetails[page.path]
  return [
    ...details.faq,
    ['Нужно ли устанавливать программу?', 'Нет, основные действия выполняются в браузере. Доступность отдельных возможностей зависит от внешнего сервиса и выбранного аккаунта.'],
    ['Как перейти к работе?', 'Нажмите основную кнопку на странице: она откроет внешний онлайн-редактор через внутренний переход /go/.'],
  ]
}

export function normalizePath(pathname: string) {
  if (pathname === '/') return '/'
  return `${pathname.replace(/^\/+|\/+$/g, '')}/`.replace(/^/, '/')
}

export function findPage(pathname: string) {
  return pageByPath.get(normalizePath(pathname)) ?? pages[0]
}
